import { gql } from '@apollo/client';

export const CampaignAgentPhonesQuery = gql`
  query CampaignAgentPhones($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      agentPhones {
        locality
        messagingServiceId
        phone
        region
        status
        vendorId
      }
    }
  }
`;

export const ProvisionAdditionalAgentPhoneMutation = gql`
  mutation ProvisionAdditionalAgentPhone($input: ProvisionAdditionalAgentPhoneInput!) {
    provisionAdditionalAgentPhone(input: $input) {
      phoneNumber
    }
  }
`;

export const DrainAgentPhoneMutation = gql`
  mutation DrainAgentPhone($input: DrainAgentPhoneInput!) {
    drainAgentPhone(input: $input)
  }
`;
